// Leistungen Data für Schlüsseldienst Dortmund

export const leistungenData = [
  {
    id: 'tueroeffnung-zugefallen',
    title: 'Türöffnung zugefallene Tür',
    slug: 'tueroeffnung-zugefallen',
    icon: '🚪',
    shortDescription: 'Tür ist zugefallen und der Schlüssel liegt innen? Wir öffnen zugefallene Türen schnell und meist ohne Beschädigung.',
    metaTitle: 'Türöffnung zugefallene Tür in Dortmund – Schlüsseldienst zum Festpreis',
    metaDescription: 'Ihre Tür ist zugefallen? Schlüsseldienst Dortmund öffnet zugefallene Türen schnell & zum Festpreis. Anfahrt inklusive. Jetzt anrufen: 0231 39085116.'
  },
  {
    id: 'tueroeffnung-verschlossen',
    title: 'Türöffnung verschlossene Tür',
    slug: 'tueroeffnung-verschlossen',
    icon: '🔐',
    shortDescription: 'Schlüssel verloren oder abgebrochen? Wir öffnen verschlossene Türen fachgerecht und beraten Sie zur weiteren Sicherheit.',
    metaTitle: 'Türöffnung verschlossene Tür Dortmund – Hilfe bei Schlüsselverlust & defektem Schloss',
    metaDescription: 'Ihre Tür ist abgeschlossen und der Schlüssel ist weg oder defekt? Schlüsseldienst Dortmund öffnet verschlossene Türen fachgerecht & fair. Anrufen: 0231 39085116.'
  },
  {
    id: 'autooeffnung',
    title: 'Autoöffnung',
    slug: 'autooeffnung',
    icon: '🚗',
    shortDescription: 'Schlüssel im Auto eingesperrt oder verloren? Wir öffnen PKW professionell und möglichst ohne Schäden.',
    metaTitle: 'Autoöffnung in Dortmund – PKW öffnen lassen ohne Schaden',
    metaDescription: 'Auto zu, Schlüssel im Fahrzeug oder verloren? Schlüsseldienst Dortmund öffnet PKW professionell & möglichst schadenfrei. Jetzt anrufen: 0231 39085116.'
  },
  {
    id: 'tresoroeffnung',
    title: 'Tresoröffnung',
    slug: 'tresoroeffnung',
    icon: '🔒',
    shortDescription: 'Tresor lässt sich nicht öffnen? Code vergessen oder Schloss defekt? Wir helfen diskret und fachgerecht.',
    metaTitle: 'Tresoröffnung in Dortmund – Hilfe bei defektem Tresor & verlorenem Code',
    metaDescription: 'Ihr Tresor lässt sich nicht mehr öffnen? Schlüsseldienst Dortmund hilft bei Tresoröffnung – diskret, fachgerecht & möglichst schadenarm. Beratung unter 0231 39085116.'
  },
  {
    id: 'schlosswechsel',
    title: 'Schlosswechsel & Zylindertausch',
    slug: 'schlosswechsel',
    icon: '🔧',
    shortDescription: 'Neues Schloss nach Einzug, Schlüsselverlust oder Einbruch? Wir tauschen Schließzylinder fachgerecht und beraten Sie.',
    metaTitle: 'Schlosswechsel & Zylindertausch in Dortmund – Mehr Sicherheit für Ihr Zuhause',
    metaDescription: 'Schlosswechsel in Dortmund gewünscht? Wir tauschen Türschlösser & Schließzylinder fachgerecht – z.B. nach Einbruch, Schlüsselverlust oder Umzug. Jetzt beraten lassen!'
  },
  {
    id: 'einbruchschutz',
    title: 'Einbruchschutz & Sicherheitsberatung',
    slug: 'einbruchschutz',
    icon: '🛡️',
    shortDescription: 'Schützen Sie Ihr Zuhause vor Einbrüchen. Wir analysieren Schwachstellen und beraten Sie zu mechanischen Sicherungslösungen.',
    metaTitle: 'Einbruchschutz in Dortmund – Sicherheitsberatung & Nachrüstung',
    metaDescription: 'Professioneller Einbruchschutz in Dortmund: Beratung, Sicherheitsanalyse vor Ort & Nachrüstung von Türen und Fenstern. Jetzt Termin vereinbaren: 0231 39085116.'
  },
  {
    id: 'einbruchschaden-reparatur',
    title: 'Einbruchschaden Reparatur',
    slug: 'einbruchschaden-reparatur',
    icon: '🔨',
    shortDescription: 'Einbruchschaden an Tür oder Fenster? Wir reparieren schnell & professionell. Für Versicherung & Polizei dokumentiert.',
    metaTitle: 'Einbruchschaden Reparatur Dortmund – Tür & Fenster Notfall-Reparatur',
    metaDescription: 'Einbruch? Wir reparieren beschädigte Türen & Fenster sofort & professionell in Dortmund. Schadensdokumentation für Versicherung inklusive. 24/7 Notdienst: 0231 39085116.'
  }
];

export const getLeistungBySlug = (slug) => {
  return leistungenData.find(l => l.slug === slug);
};
